import { ThemeTokens } from '../../theme';

export function useThemeToken(key: ThemeTokens) {
  return `var(--theme--tokens--${key})`;
}
